import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-notification-menu-item',
    templateUrl: './notification-menu-item.html',
    styleUrls: ['./notification-menu-item.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterModule]
})
export class NotificationMenuItemComponent  {
  @Input() title: string;
  @Input() description: string;
  @Input() date: string | null;
  @Input() time: string | null;

}
